import { Grid2, Skeleton } from '@mui/material'
import React, { memo } from 'react'

const DataGridSkeleton = memo(() => {
    return (
        <Grid2 container height={'100%'} flexDirection={'column'} overflow={'hidden'} borderRadius={4} spacing={2}>
            <Grid2 container spacing={2}>
                {[...Array(6)].map((s, i) =>
                    <Grid2 size={'grow'} key={i}>
                        <Skeleton variant='rectangular' height={50} width={'100%'} />
                    </Grid2>)
                }
            </Grid2>
            <Grid2 size={'grow'} container flexDirection={'column'} spacing={1}>
                {[...Array(3)].map((s, i) =>
                    <Grid2 key={i}>
                        <Skeleton variant='rectangular' height={50} width={'100%'} />
                    </Grid2>)
                }
                <Grid2 size={'grow'}>
                    <Skeleton variant='rectangular' height={'100%'} width={'100%'} />
                </Grid2>
            </Grid2>
            <Grid2>
                <Skeleton variant='rectangular' height={50} width={'100%'} />
            </Grid2>
        </Grid2>
    )
})

export default DataGridSkeleton